// extracted by mini-css-extract-plugin
module.exports = {"dialogPrepaidJtails":"DialogPrepaid_dialogPrepaidJtails_3O2qA","isStyleDingBeauty":"DialogPrepaid_isStyleDingBeauty_2Ji0T"};